(function () {
  'use strict';

  var SECTION_TYPE = 'home-reviews';
  var instances = {};

  function prefersReducedMotion() {
    return (
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  var AUTOPLAY_DELAY = 5000;

  function ReviewsSlider(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-reviews-viewport]');
    this.track = root.querySelector('.home-reviews__track');
    this.items = toArray(root.querySelectorAll('[data-reviews-item]'));
    this.realItems = this.items.slice();
    this.looped = false;
    this.active = false;
    this.settleTimer = null;
    this.autoTimer = null;
    this.autoPaused = false;
    this.desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;

    if (!this.viewport || this.items.length === 0) {
      return;
    }

    this.onScroll = this.handleScroll.bind(this);
    this.onResize = this.handleResize.bind(this);
    this.onPause = this.pauseAuto.bind(this);
    this.onResume = this.resumeAuto.bind(this);
    this.onVisibility = this.handleVisibility.bind(this);

    this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    root.addEventListener('mouseenter', this.onPause);
    root.addEventListener('mouseleave', this.onResume);
    root.addEventListener('focusin', this.onPause);
    root.addEventListener('focusout', this.onResume);
    document.addEventListener('visibilitychange', this.onVisibility);

    this.refresh();
  }

  ReviewsSlider.prototype.isScrollable = function () {
    return this.viewport.scrollWidth - this.viewport.clientWidth > 1;
  };

  ReviewsSlider.prototype.refresh = function () {
    this.active = this.isScrollable();

    if (this.active) {
      this.enableLoop();
      this.viewport.setAttribute('tabindex', '0');
      this.viewport.setAttribute('role', 'group');
      this.viewport.setAttribute('aria-roledescription', 'carousel');
    } else {
      this.disableLoop();
      this.viewport.removeAttribute('tabindex');
      this.viewport.removeAttribute('role');
      this.viewport.removeAttribute('aria-roledescription');
    }

    this.startAuto();
  };

  ReviewsSlider.prototype.canAutoplay = function () {
    if (!this.active || prefersReducedMotion()) {
      return false;
    }
    return !this.desktopQuery || this.desktopQuery.matches;
  };

  ReviewsSlider.prototype.startAuto = function () {
    var self = this;

    this.stopAuto();

    if (!this.canAutoplay() || this.autoPaused || document.hidden) {
      return;
    }

    this.autoTimer = window.setInterval(function () {
      self.scrollToIndex(self.currentIndex() + 1);
    }, AUTOPLAY_DELAY);
  };

  ReviewsSlider.prototype.stopAuto = function () {
    if (this.autoTimer !== null) {
      window.clearInterval(this.autoTimer);
      this.autoTimer = null;
    }
  };

  ReviewsSlider.prototype.pauseAuto = function () {
    this.autoPaused = true;
    this.stopAuto();
  };

  ReviewsSlider.prototype.resumeAuto = function () {
    this.autoPaused = false;
    this.startAuto();
  };

  ReviewsSlider.prototype.handleVisibility = function () {
    if (document.hidden) {
      this.stopAuto();
    } else {
      this.startAuto();
    }
  };

  ReviewsSlider.prototype.enableLoop = function () {
    if (this.looped || !this.track || this.realItems.length < 2) {
      return;
    }

    var lead = document.createDocumentFragment();
    var tail = document.createDocumentFragment();

    this.realItems.forEach(function (item) {
      var before = item.cloneNode(true);
      var after = item.cloneNode(true);
      [before, after].forEach(function (clone) {
        clone.setAttribute('data-reviews-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        toArray(clone.querySelectorAll('a, button')).forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
      });
      lead.appendChild(before);
      tail.appendChild(after);
    });

    this.track.insertBefore(lead, this.track.firstChild);
    this.track.appendChild(tail);

    this.items = toArray(this.track.querySelectorAll('[data-reviews-item]'));
    this.looped = true;
    this.jumpToRealStart();
  };

  ReviewsSlider.prototype.disableLoop = function () {
    if (!this.looped) {
      return;
    }
    toArray(this.track.querySelectorAll('[data-reviews-clone]')).forEach(function (clone) {
      clone.parentNode.removeChild(clone);
    });
    this.items = this.realItems.slice();
    this.looped = false;
  };

  ReviewsSlider.prototype.loopSpan = function () {
    var count = this.realItems.length;
    var firstReal = this.items[count];
    var firstTrailingClone = this.items[count * 2];
    if (!firstReal || !firstTrailingClone) {
      return 0;
    }
    return firstTrailingClone.offsetLeft - firstReal.offsetLeft;
  };

  ReviewsSlider.prototype.jumpToRealStart = function () {
    var base = this.items[0].offsetLeft;
    this.viewport.scrollLeft = this.realItems[0].offsetLeft - base;
  };

  ReviewsSlider.prototype.normalizeLoop = function () {
    if (!this.looped) {
      return;
    }

    var base = this.items[0].offsetLeft;
    var span = this.loopSpan();
    var start = this.realItems[0].offsetLeft - base;
    var position = this.viewport.scrollLeft;

    if (position < start - 1) {
      this.viewport.scrollLeft = position + span;
    } else if (position > start + span - 1) {
      this.viewport.scrollLeft = position - span;
    }
  };

  ReviewsSlider.prototype.currentIndex = function () {
    var base = this.items[0].offsetLeft;
    var position = this.viewport.scrollLeft;
    var closest = 0;
    var smallest = Infinity;

    for (var i = 0; i < this.items.length; i++) {
      var distance = Math.abs(this.items[i].offsetLeft - base - position);
      if (distance < smallest) {
        smallest = distance;
        closest = i;
      }
    }

    return closest;
  };

  ReviewsSlider.prototype.scrollToIndex = function (index) {
    var bounded = Math.max(0, Math.min(index, this.items.length - 1));
    var left = this.items[bounded].offsetLeft - this.items[0].offsetLeft;

    try {
      this.viewport.scrollTo({
        left: left,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    } catch (error) {
      this.viewport.scrollLeft = left;
    }
  };

  ReviewsSlider.prototype.handleScroll = function () {
    var self = this;

    window.clearTimeout(this.settleTimer);
    this.settleTimer = window.setTimeout(function () {
      self.normalizeLoop();
    }, 200);
  };

  ReviewsSlider.prototype.handleResize = function () {
    this.refresh();
  };

  ReviewsSlider.prototype.destroy = function () {
    if (!this.viewport) {
      return;
    }

    this.stopAuto();
    this.disableLoop();
    this.viewport.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.root.removeEventListener('mouseenter', this.onPause);
    this.root.removeEventListener('mouseleave', this.onResume);
    this.root.removeEventListener('focusin', this.onPause);
    this.root.removeEventListener('focusout', this.onResume);
    document.removeEventListener('visibilitychange', this.onVisibility);

    window.clearTimeout(this.settleTimer);
  };

  function initWithin(scope) {
    var roots = (scope || document).querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]');

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var id = root.getAttribute('data-section-id');

      if (!id || instances[id]) {
        continue;
      }

      instances[id] = new ReviewsSlider(root);
    }
  }

  function destroySection(id) {
    if (instances[id]) {
      instances[id].destroy();
      delete instances[id];
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (id) {
      destroySection(id);
    }
    initWithin(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (id) {
      destroySection(id);
    }
  });
})();
